module.exports = __webpack_public_path__ + "static/media/20240319084838_IMG_6018-min.c1522495.JPG";